import { render, staticRenderFns } from "./stop-subscriptions-summary.vue?vue&type=template&id=2ea8563c&functional=true&"
import script from "./stop-subscriptions-summary.vue?vue&type=script&lang=js&"
export * from "./stop-subscriptions-summary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports